import { AbstractControl, UntypedFormArray, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { COUNTRY_DIAL_CODES, CountryDialCodeDto } from '../../../../../../common/constants/country-dial-codes';

export function truckSealNumberValidator(formControl: AbstractControl): ValidationErrors {
  if (!formControl.parent) {
    return null;
  }

  if (formControl.parent.parent.get('trailerSealingPhoto').get('number').value) {
    return Validators.required(formControl);
  }
  return null;
}

export function sealPhotoValidator(formControl: AbstractControl): ValidationErrors {
  if (!formControl.parent) {
    return null;
  }

  if (formControl.parent.get('number').value) {
    return Validators.required(formControl);
  }

  return null;
}

export function uliListValidator(formArray: UntypedFormArray): ValidationErrors {
  return formArray.controls
    .reduce((acc: AbstractControl[], array: UntypedFormArray) => acc.concat(array.controls), [])
    .some((control: AbstractControl) => control.value?.selected)
    ? null
    : {
        required: true,
      };
}

export function smsNotificationValidator(supportedCountryCodes: string[], useDriverApp: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (useDriverApp) {
      const phoneValue: string = control?.value;
      const dialCodeValue: string = phoneValue
        ? phoneValue.substring(phoneValue.indexOf('+') + 1, phoneValue.indexOf(' '))
        : '';
      const countryDialCodes: string[] = COUNTRY_DIAL_CODES.filter(
        (item: CountryDialCodeDto) => item.dialCodeValue === dialCodeValue,
      ).map((item: CountryDialCodeDto) => item.countryDialCode);

      if (countryDialCodes.length > 0) {
        return countryDialCodes.some((code: string) => supportedCountryCodes.includes(code))
          ? null
          : { unsupportedSMS: true };
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}
